import _styled41 from "../web_modules/styled-components.js";
import _styled40 from "../web_modules/styled-components.js";
import _styled39 from "../web_modules/styled-components.js";
import _styled38 from "../web_modules/styled-components.js";
import _styled37 from "../web_modules/styled-components.js";
import _styled36 from "../web_modules/styled-components.js";
import _styled35 from "../web_modules/styled-components.js";
import _styled34 from "../web_modules/styled-components.js";
import _styled33 from "../web_modules/styled-components.js";
import _styled32 from "../web_modules/styled-components.js";
import _styled31 from "../web_modules/styled-components.js";
import _styled30 from "../web_modules/styled-components.js";
import _styled29 from "../web_modules/styled-components.js";
import _styled28 from "../web_modules/styled-components.js";
import _styled27 from "../web_modules/styled-components.js";
import _styled26 from "../web_modules/styled-components.js";
import _styled25 from "../web_modules/styled-components.js";
import _styled24 from "../web_modules/styled-components.js";
import _styled23 from "../web_modules/styled-components.js";
import _styled22 from "../web_modules/styled-components.js";
import _styled21 from "../web_modules/styled-components.js";
import _styled20 from "../web_modules/styled-components.js";
import _styled19 from "../web_modules/styled-components.js";
import _styled18 from "../web_modules/styled-components.js";
import _styled17 from "../web_modules/styled-components.js";
import _styled16 from "../web_modules/styled-components.js";
import _styled15 from "../web_modules/styled-components.js";
import _styled14 from "../web_modules/styled-components.js";
import _styled13 from "../web_modules/styled-components.js";
import _styled12 from "../web_modules/styled-components.js";
import _styled11 from "../web_modules/styled-components.js";
import _styled10 from "../web_modules/styled-components.js";
import _styled9 from "../web_modules/styled-components.js";
import _styled8 from "../web_modules/styled-components.js";
import _styled7 from "../web_modules/styled-components.js";
import _styled6 from "../web_modules/styled-components.js";
import _styled5 from "../web_modules/styled-components.js";
import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";
import * as React from "../web_modules/react.js";
import { Link, useHistory } from "../web_modules/react-router-dom.js";
import { Calendar, ChangeMonthButton, CurrentMonth, CalendarMonth, CalendarMonthHeading, CalendarMonthDays, CalendarMonthCell, CalendarMonthDayNumber } from "../web_modules/react-clndr.js";
import "../web_modules/react-clndr/index.css";
import { useAsyncStatus, AsyncStates } from "../web_modules/use-async-status.js";
import { LanguageSelector, Spinner, formatDate, formatDateTimeRange, makeDate } from "../web_modules/@ticketbutler/toolbox.js";
import "../web_modules/@ticketbutler/toolbox/dist/style.css";
import { makeSearchParamString, useLanguage, styles, getThemedButton, floatIfNotRound, API_HOST } from "./app.js";
import { isIframe, DescriptiveTextLabel, useIframeTypes, urlParams, PaymentIcons } from "./shared.js";
import freeArrow from "./assets/icons/arrow.png";
import { useTranslation } from "../web_modules/react-i18next.js";
const tags = urlParams.get("tags");

function capitaliseFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getDayId(date) {
  const year = date.getFullYear();
  const month = date.getMonth();
  const monthDay = date.getDate();
  return [year, month, monthDay].join("-");
}

const eventListButton = {
  fontSize: 18,
  margin: 15,
  width: 200,
  alignItems: "center",
  padding: 5,
  "@media (max-width: 420px)": {
    width: 120,
    height: 44,
    margin: 2.5,
    fontSize: 12
  }
}; // Handle event button links so that iframe detail modals open the external
// modal

function EventListLink({
  pathname,
  isDetailIframe,
  children
}) {
  if (isDetailIframe) {
    return /*#__PURE__*/React.createElement("div", {
      onClick: function () {
        parent.postMessage({
          type: "TICKETBUTLER_CHECKOUT_MODAL",
          open: true,
          url: window.location.origin + pathname
        }, "*");
      }
    }, children);
  } else {
    return /*#__PURE__*/React.createElement(Link, {
      style: {
        textDecoration: "none"
      },
      to: {
        pathname
      }
    }, children);
  }
}

var _StyledDiv = _styled("div").withConfig({
  displayName: "event_list___StyledDiv",
  componentId: "sc-1v4msh0-0"
})(["", ""], p => p._css);

export function EventList({
  whitelabel,
  theme
}) {
  const language = useLanguage();
  const history = useHistory();
  const showCalendar = urlParams.has("calendar");
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    _css: isIframe ? {
      minHeight: 420
    } : {
      minHeight: 600
    }
  }, /*#__PURE__*/React.createElement("div", null, isIframe && /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement(LanguageSelector, {
    current: language,
    onSelect: newLanguage => {
      const newUrl = location.pathname.replace(`/${language}/`, `/${newLanguage}/`);
      history.push(newUrl + makeSearchParamString());
    }
  })), showCalendar ? /*#__PURE__*/React.createElement(ListWithCalendar, {
    whitelabel: whitelabel,
    theme: theme
  }) : /*#__PURE__*/React.createElement(List, {
    whitelabel: whitelabel,
    theme: theme
  })));
}

const Arrow = ({
  color
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 1000 1000"
}, /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"
}));

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv2",
  componentId: "sc-1v4msh0-1"
})({
  display: "flex",
  justifyContent: "center",
  padding: "80px 10px",
  fontFamily: "Times New Roman"
});

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv3",
  componentId: "sc-1v4msh0-2"
})({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  marginTop: "80"
});

var _StyledDiv4 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv4",
  componentId: "sc-1v4msh0-3"
})({
  display: "flex",
  justifyContent: "center",
  padding: "80px 10px",
  fontFamily: "Times New Roman"
});

var _StyledDiv5 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv5",
  componentId: "sc-1v4msh0-4"
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  width: "100%",
  maxWidth: 400,
  margin: "20px auto",
  padding: 20,
  boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.1)",
  borderRadius: 5,
  backgroundColor: "white",
  "[data-react-any-calendar-table]": {
    position: "relative"
  },
  "[data-react-any-calendar-table] thead tr": {
    height: 32
  },
  "[data-react-any-calendar-table] tbody tr": {
    height: 48
  },
  "[data-react-any-calendar-table] td": {
    width: 48,
    "&[data-selected]": {
      border: "none",
      backgroundColor: "#2684ff",
      color: "white"
    },
    "&:hover": {
      borderColor: "#9A9A9A",
      transition: "100ms border-color"
    }
  },
  "[data-react-any-calendar-month-button]": {
    backgroundColor: "transparent",
    border: "none",
    width: 45,
    padding: 10,
    margin: "0 10px",
    "&:first-child": {
      transform: "rotate(180deg)"
    }
  },
  "@media (max-width: 420px)": {
    padding: 5,
    "[data-react-any-calendar-table] td": {
      width: 38
    }
  }
});

var _StyledDiv6 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv6",
  componentId: "sc-1v4msh0-5"
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  marginBottom: 10
});

var _StyledDiv7 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv7",
  componentId: "sc-1v4msh0-6"
})(p => ({
  position: "absolute",
  backgroundColor: p._css2,
  width: "100%",
  height: 1
}));

var _StyledDiv8 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv8",
  componentId: "sc-1v4msh0-7"
})({
  display: "flex"
});

var _StyledDiv9 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv9",
  componentId: "sc-1v4msh0-8"
})(p => ({
  fontSize: 10,
  fontWeight: "bold",
  marginLeft: 5,
  marginTop: p._css3
}));

var _StyledDiv10 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv10",
  componentId: "sc-1v4msh0-9"
})(p => ({
  minHeight: p._css4
}));

var _StyledP = _styled("p").withConfig({
  displayName: "event_list___StyledP",
  componentId: "sc-1v4msh0-10"
})({
  textAlign: "center"
});

function ListWithCalendar({
  whitelabel,
  theme
}) {
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  const [firstEventStatus, setFirstEventStatus] = React.useState(AsyncStates.Pending);
  const [selectedDate, setSelectedDate] = React.useState();
  const [noEvents, setNoEvents] = React.useState(false);
  const {
    trigger: getEventsForCalendar,
    lastResult: events,
    status
  } = useAsyncStatus(async function getEventsForCalendar(year, month) {
    const eventsPath = location.pathname.replace("/iframe", "").split("/events/");
    const basePath = API_HOST + (eventsPath.length > 1 ? "/events/calendar/" + eventsPath[1] : "/events/calendar/");
    const req = await fetch(basePath + makeSearchParamString(["year", year], ["month", month], ["tag", tags]));
    const res = await req.json();

    if (req.ok) {
      return res;
    } else {
      throw res;
    }
  });
  React.useEffect(function () {
    async function getFirstEventDate() {
      const eventsPath = location.pathname.replace("/iframe", "").split("/events/");
      const basePath = API_HOST + (eventsPath.length > 1 ? "/events/calendar-start-date/" + eventsPath[1] : "/events/calendar-start-date/");
      const req = await fetch([basePath, tags ? "?tag=" + tags : null].filter(Boolean).join(""));

      if (req.ok) {
        if (req.status === 204) {
          // API returns 204 if there are no events
          setNoEvents(true);
        } else {
          const firstEventDateResult = await req.json();
          const selectedDateFromResponse = new Date(firstEventDateResult.start_date);
          setSelectedDate(selectedDateFromResponse);

          if (selectedDateFromResponse) {
            getEventsForCalendar(selectedDateFromResponse.getFullYear(), selectedDateFromResponse.getMonth() + 1);
          }
        }

        setFirstEventStatus(AsyncStates.Success);
      } else {
        setFirstEventStatus(AsyncStates.Error);
      }
    }

    getFirstEventDate();
  }, [setSelectedDate, getEventsForCalendar]);
  const eventsByDay = events && events.reduce(function (acc, event) {
    const eventDayId = getDayId(new Date(event.start_date));
    const eventsForDayByCategory = acc[eventDayId] || [];
    return { ...acc,
      [eventDayId]: eventsForDayByCategory.concat(event)
    };
  }, {});
  let date = "";

  if (selectedDate) {
    const newDate = new Date(selectedDate);
    const yyyy = newDate.getFullYear();
    const mm = newDate.getMonth() + 1;
    const dd = newDate.getDate();
    date = String(yyyy + "-" + mm + "-" + dd);
  }

  const eventsForDayByCategory = selectedDate && eventsByDay && eventsByDay[getDayId(selectedDate)] || []; // Empty if none

  const renderCalendar = !!eventsByDay;

  if (firstEventStatus === AsyncStates.Error) {
    return /*#__PURE__*/React.createElement(_StyledDiv2, null, /*#__PURE__*/React.createElement("h1", null, t("event.calendarNotAvailable")));
  }

  if (firstEventStatus === AsyncStates.Pending || status === AsyncStates.Pending && !eventsByDay) {
    return /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement(Spinner, {
      color: isIframe ? "white" : theme.colour_primary
    }), /*#__PURE__*/React.createElement("p", null, t("event.loadingEvents")));
  }

  if (noEvents) {
    return /*#__PURE__*/React.createElement(_StyledDiv4, null, /*#__PURE__*/React.createElement("h1", null, t("event.noEvents")));
  }

  const onChangeDate = date => {
    getEventsForCalendar(date.getFullYear(), date.getMonth() + 1);
    setSelectedDate(date);
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledDiv5, {
    "data-testid": "calendar"
  }, renderCalendar && /*#__PURE__*/React.createElement(Calendar, {
    initialDate: selectedDate,
    onChangeDate: onChangeDate
  }, /*#__PURE__*/React.createElement(_StyledDiv6, null, /*#__PURE__*/React.createElement(ChangeMonthButton, {
    interval: -1,
    onClick: onChangeDate
  }, /*#__PURE__*/React.createElement(Arrow, {
    color: theme.colour_primary
  })), /*#__PURE__*/React.createElement(CurrentMonth, null, currentMonthDate => currentMonthDate.toLocaleDateString(language === "da" ? "da-DK" : "en-GB", {
    month: "long",
    year: "numeric"
  })), /*#__PURE__*/React.createElement(ChangeMonthButton, {
    onClick: onChangeDate
  }, /*#__PURE__*/React.createElement(Arrow, {
    color: theme.colour_primary
  }))), /*#__PURE__*/React.createElement(CalendarMonth, null, /*#__PURE__*/React.createElement(CalendarMonthHeading, {
    weekLabels: Array.from({
      length: 7
    }).map(function (_, index) {
      const today = new Date();
      const day = today.getDay();
      const diff = today.getDate() - day + (day == 0 ? -6 : 1) + index;
      today.setDate(diff);
      const weekDay = today;
      const result = weekDay.toLocaleDateString(language === "da" ? "da-DK" : "en-GB", {
        weekday: "short"
      });
      return window.innerWidth < 320 ? result.charAt(0) : result;
    })
  }), /*#__PURE__*/React.createElement(_StyledDiv7, {
    _css2: theme.colour_primary
  }), /*#__PURE__*/React.createElement(CalendarMonthDays, null, function (weekDays) {
    return weekDays.map(function (day, index) {
      if (day.date) {
        const dayId = getDayId(day.date);
        return /*#__PURE__*/React.createElement(CalendarMonthCell, {
          key: dayId,
          day: day,
          style: eventsByDay[dayId] ? {
            backgroundColor: "#F1F1F1",
            color: "#333",
            fontSize: window.innerWidth < 320 ? 13 : 16
          } : {
            fontSize: window.innerWidth < 320 ? 13 : 16
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            position: "absolute",
            top: 2,
            right: 2,
            textAlign: "right",
            display: "flex"
          }
        }, eventsByDay && eventsByDay[dayId] && (eventsByDay[dayId].length > 4 ? /*#__PURE__*/React.createElement(_StyledDiv8, null, // Show 2 dots and + X
        eventsByDay[dayId] // Put the active ones at the top, so we don't
        // just show red dots
        .sort(function (event) {
          return getIsAvailable(event) ? 0 : 1;
        }).slice(0, 2).map(event => /*#__PURE__*/React.createElement(EventDot, {
          key: event.uuid || event.pk,
          available: getIsAvailable(event),
          salesNotStarted: Boolean(event.sales_start_on)
        })), /*#__PURE__*/React.createElement(_StyledDiv9, {
          _css3: -2
        }, "+", eventsByDay[dayId].length - 2)) : eventsByDay[dayId].sort(function (event) {
          return getIsAvailable(event) ? 0 : 1;
        }).map(event => /*#__PURE__*/React.createElement(EventDot, {
          key: event.uuid || event.pk,
          available: getIsAvailable(event),
          salesNotStarted: Boolean(event.sales_start_on)
        })))), /*#__PURE__*/React.createElement(CalendarMonthDayNumber, null));
      } else {
        return /*#__PURE__*/React.createElement("td", {
          key: `empty-day-${index}`
        });
      }
    });
  })))), /*#__PURE__*/React.createElement(_StyledDiv10, {
    _css4: isIframe ? "auto" : 300
  }, date && eventsForDayByCategory.length > 0 ? /*#__PURE__*/React.createElement(List, {
    whitelabel: whitelabel,
    theme: theme,
    date: date
  }) : /*#__PURE__*/React.createElement(_StyledP, null, selectedDate && status !== AsyncStates.Pending && /*#__PURE__*/React.createElement("span", null, t("event.noEventsFor"), " ", selectedDate.toLocaleDateString(language === "da" ? "da-DK" : "en-GB", {
    month: "long",
    year: "numeric",
    day: "numeric"
  })), !selectedDate && t("event.selectDay"))));
}

function getIsAvailable(event) {
  if (event.is_sold_out || event.is_deleted || event.is_expired) return false;
  return true;
}

function EventDot({
  available,
  salesNotStarted
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 2,
      width: 8,
      height: 8,
      backgroundColor: available ? "#84C069" : salesNotStarted ? "#FFD300" : "#EF6363",
      borderRadius: "50%",
      boxShadow: "1px 1px 1px #c1c1c1"
    }
  });
}

function isEventGroup(obj) {
  return "groupName" in obj;
}

var _StyledDiv11 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv11",
  componentId: "sc-1v4msh0-11"
})(["", ""], p => p._css5);

var _StyledDiv12 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv12",
  componentId: "sc-1v4msh0-12"
})({
  minWidth: 160,
  "@media(max-width: 320px)": {
    display: "contents"
  }
});

var _StyledH = _styled("h2").withConfig({
  displayName: "event_list___StyledH",
  componentId: "sc-1v4msh0-13"
})({
  fontSize: 18,
  margin: "10px 0",
  "@media (max-width: 420px)": {
    fontSize: 16,
    margin: "5px 0"
  }
});

var _StyledSpan = _styled("span").withConfig({
  displayName: "event_list___StyledSpan",
  componentId: "sc-1v4msh0-14"
})({
  "@media(max-width: 420px)": {
    fontSize: 14
  }
});

var _StyledSpan2 = _styled("span").withConfig({
  displayName: "event_list___StyledSpan2",
  componentId: "sc-1v4msh0-15"
})(p => ({
  fontWeight: p._css6,
  "@media(max-width: 420px)": {
    fontSize: 14
  }
}));

var _StyledP2 = _styled("p").withConfig({
  displayName: "event_list___StyledP2",
  componentId: "sc-1v4msh0-16"
})(["", ""], p => p._css7);

var _StyledP3 = _styled("p").withConfig({
  displayName: "event_list___StyledP3",
  componentId: "sc-1v4msh0-17"
})(["", ""], p => p._css8);

var _StyledDiv13 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv13",
  componentId: "sc-1v4msh0-18"
})({
  margin: "7.5px 0",
  fontSize: 14,
  "@media(max-width: 420px)": {
    fontSize: 13
  }
});

var _StyledDiv14 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv14",
  componentId: "sc-1v4msh0-19"
})(["", ""], p => p._css9);

var _StyledDiv15 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv15",
  componentId: "sc-1v4msh0-20"
})(["", ""], p => p._css10);

var _StyledDiv16 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv16",
  componentId: "sc-1v4msh0-21"
})(["", ""], p => p._css11);

var _StyledDiv17 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv17",
  componentId: "sc-1v4msh0-22"
})({
  display: "flex",
  alignItems: "center",
  "@media (max-width: 500px)": {
    flexDirection: "column"
  }
});

var _StyledButton = _styled("button").withConfig({
  displayName: "event_list___StyledButton",
  componentId: "sc-1v4msh0-23"
})(["", ""], p => p._css12);

var _StyledP4 = _styled("p").withConfig({
  displayName: "event_list___StyledP4",
  componentId: "sc-1v4msh0-24"
})({
  textAlign: "right"
});

var _StyledButton2 = _styled("button").withConfig({
  displayName: "event_list___StyledButton2",
  componentId: "sc-1v4msh0-25"
})(["", ""], p => p._css13);

var _StyledDiv18 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv18",
  componentId: "sc-1v4msh0-26"
})({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  marginTop: "80"
});

var _StyledP5 = _styled("p").withConfig({
  displayName: "event_list___StyledP5",
  componentId: "sc-1v4msh0-27"
})({
  textAlign: "center"
});

var _StyledP6 = _styled("p").withConfig({
  displayName: "event_list___StyledP6",
  componentId: "sc-1v4msh0-28"
})({
  textAlign: "center"
});

export function List({
  whitelabel,
  theme,
  date
}) {
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  const {
    isIframe,
    isDetailIframe
  } = useIframeTypes(whitelabel);
  const [openGroupIndex, setOpenGroupIndex] = React.useState(null);
  const {
    trigger: getEventsForDayByCategory,
    lastResult: eventsForDayByCategory,
    status: EVENT_LIST_STATUS
  } = useAsyncStatus(async function getEventsForDayByCategory() {
    const eventsPath = window.location.pathname.replace("/iframe", "").split("/events/");
    const basePath = API_HOST + (eventsPath.length > 1 ? "/events/list/" + eventsPath[1] : "/events/list/");
    const req = await fetch([basePath, makeSearchParamString(["date", date], ["tag", tags])].filter(Boolean).join(""));
    const res = await req.json();

    if (req.ok) {
      // Organise events into event groups. Events without groups are put
      // into "ungrouped"
      return res.reduce(function (acc, event) {
        if (event.groups.length > 0) {
          event.groups.forEach(function ({
            name
          }) {
            const group = acc.find(function (item) {
              if (isEventGroup(item)) {
                return name === item.groupName;
              }

              return false;
            });

            if (group && isEventGroup(group)) {
              // This group already exists, let's add this event
              group.events.push(event);
            } else {
              // The group doesn't exist yet, let's initiate it with the
              // event at the end of the list
              acc.push({
                groupName: name,
                events: [event]
              });
            }
          });
        } else {
          // Event doesn't belong to any groups, so add it to the end of the
          // list
          acc.push(event);
        }

        return acc;
      }, []);
    } else {
      throw res;
    }
  }, [date]);
  React.useEffect(function () {
    getEventsForDayByCategory();
  }, [getEventsForDayByCategory]);

  const renderPriceRange = ({
    min,
    max
  }) => {
    if (min == max) {
      return min = min == "0" ? t("event.free") : floatIfNotRound(parseInt(min)) + " " + whitelabel.currency_code;
    } else {
      min = min == "0" ? t("event.free") : floatIfNotRound(parseInt(min));
      return max == "0" ? t("event.free") : min + " - " + floatIfNotRound(parseInt(max)) + " " + whitelabel.currency_code;
    }
  };

  function renderEventRow(event, borderBottomStyle) {
    // @ts-expect-error: Happy with unsafe access
    const customButtonText = event[`choose_tickets_button_text_${language}`];
    const tagContainer = {
      display: "flex",
      margin: "10px 0",
      width: "max-content"
    };
    return /*#__PURE__*/React.createElement(_StyledDiv11, {
      key: event.pk,
      _css5: [whitelabel.event_list_show_date_only && {
        alignItems: "center"
      }, {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        padding: "15px 0",
        borderBottom: borderBottomStyle,
        "@media(max-width: 420px)": {
          padding: "10px 0"
        },
        "@media(max-width: 320px)": {
          flexDirection: "column",
          alignItems: "normal"
        }
      }]
    }, /*#__PURE__*/React.createElement(_StyledDiv12, null, !whitelabel.event_list_show_date_only && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledH, null, event.title)), event.date_range ? /*#__PURE__*/React.createElement(_StyledSpan, null, formatDateTimeRange(makeDate(event.date_range?.min, true), makeDate(event.date_range?.max, true), {
      dateLocale: language === "da" ? "da-DK" : undefined,
      showTime: false,
      shortForm: window.innerWidth < 420
    })) : /*#__PURE__*/React.createElement(_StyledSpan2, {
      _css6: whitelabel.event_list_show_date_only ? "bold" : "normal"
    }, capitaliseFirstLetter(event.end_date ? formatDateTimeRange(makeDate(event.start_date, true), makeDate(event.end_date, true), {
      dateLocale: language === "da" ? "da-DK" : undefined,
      shortForm: window.innerWidth < 420
    }) : formatDate(makeDate(event.start_date, true), language === "da" ? "da-DK" : undefined, {
      weekday: window.innerWidth > 420 ? "long" : "short",
      year: "numeric",
      month: window.innerWidth > 420 ? "long" : "short",
      day: "numeric"
    }))), !whitelabel.event_list_show_date_only && event.address && (event.address.street ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledP2, {
      _css7: [styles.caption, {
        margin: "0px"
      }]
    }, (event.address.venue ? event.address.venue + " - " : "") + event.address.street + " ", " "), /*#__PURE__*/React.createElement(_StyledP3, {
      _css8: [styles.caption, {
        margin: "0px"
      }]
    }, event.address.postcode + " " + event.address.city)) : /*#__PURE__*/React.createElement("p", null, "", " ")), !whitelabel.hide_price_range && // No price range if tickets are not yet for sale
    event.price_range && // Hide the price if the sale of ticket types has not started yet
    typeof event.price_range.min === "number" && typeof event.price_range.max === "number" && /*#__PURE__*/React.createElement(_StyledDiv13, null, renderPriceRange(event.price_range)), !event.is_sold_out && event.show_few_tickets_left_tag && /*#__PURE__*/React.createElement(_StyledDiv14, {
      _css9: tagContainer
    }, /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.fewTicketsLeft"))), event.is_temporarily_sold_out && /*#__PURE__*/React.createElement(_StyledDiv15, {
      _css10: tagContainer
    }, /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.temporarilySoldOut"))), Boolean(event.sales_start_on) && /*#__PURE__*/React.createElement(_StyledDiv16, {
      _css11: tagContainer
    }, /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.ticketSalesNotStarted")))), /*#__PURE__*/React.createElement(_StyledDiv17, null, event.is_deleted || event.is_expired || event.is_sold_out && !event.show_waiting_list ? /*#__PURE__*/React.createElement(_StyledButton, {
      type: "button",
      disabled: true,
      _css12: [getThemedButton(theme), eventListButton, {
        backgroundColor: "#c5c9c6"
      }]
    }, /*#__PURE__*/React.createElement("div", null, t("event.soldOut"))) : event.sales_start_on && // Don't show "ticket sales start" if a button text has been
    // provided (often used to direct users to a notification flow)
    !customButtonText ? /*#__PURE__*/React.createElement(_StyledP4, null, t("event.ticketSalesStart"), ":", /*#__PURE__*/React.createElement("br", null), formatDate(makeDate(event.sales_start_on, true), language === "da" ? "da-DK" : undefined)) : /*#__PURE__*/React.createElement(EventListLink, {
      pathname: "/" + language + "/e/" + event.title_url + "/" + makeSearchParamString(["back_arrow_pathname", location.pathname], ["iframe", isIframe ? "true" : undefined]),
      isDetailIframe: isDetailIframe
    }, /*#__PURE__*/React.createElement(_StyledButton2, {
      _css13: [getThemedButton(theme), eventListButton]
    }, customButtonText || (event.is_sold_out ? t("event.enrollToWaitingList") : t("event.chooseTickets"))))));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, EVENT_LIST_STATUS === AsyncStates.Pending ? /*#__PURE__*/React.createElement(_StyledDiv18, null, /*#__PURE__*/React.createElement(Spinner, {
    color: isIframe ? "white" : theme.colour_primary
  }), /*#__PURE__*/React.createElement("p", null, t("event.loadingEvents"))) : EVENT_LIST_STATUS === AsyncStates.Success ? eventsForDayByCategory && eventsForDayByCategory.length === 0 ? /*#__PURE__*/React.createElement(_StyledP5, null, t("event.noEvents")) : eventsForDayByCategory && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "white",
      borderRadius: 10,
      maxWidth: 720,
      padding: 15,
      margin: "0 auto"
    }
  }, eventsForDayByCategory.map(function (item, itemIndex) {
    const lastItemInList = itemIndex === eventsForDayByCategory.length - 1;

    if (isEventGroup(item)) {
      const lastEvent = item.events[item.events.length - 1];
      return /*#__PURE__*/React.createElement(GroupList, {
        key: itemIndex,
        name: item.groupName,
        theme: theme // Note: we assume the events are already ordered by date
        ,
        earliestDate: makeDate(item.events[0].start_date, true),
        latestDate: makeDate(lastEvent.end_date || lastEvent.start_date, true),
        numberOfEvents: item.events.length,
        salesNotStarted: item.events.every(({
          sales_start_on
        }) => Boolean(sales_start_on)),
        open: openGroupIndex === itemIndex,
        onToggle: function () {
          if (openGroupIndex === itemIndex) {
            // Group is already open, close it
            setOpenGroupIndex(null);
          } else {
            setOpenGroupIndex(itemIndex);
          }
        },
        showFewTicketsLeftTag: item.events.filter(event => event.show_few_tickets_left_tag).length > 0 && item.events.filter(event => !event.is_sold_out).length > 0,
        showTemporarilySoldOutTag: item.events.every(event => event.is_temporarily_sold_out)
      }, item.events.map(function (event, eventIndex) {
        const lastEventInGroup = eventIndex === item.events.length - 1;
        return renderEventRow(event, lastItemInList ? "none" : "1px solid " + (lastEventInGroup ? "#333" : "#d3d3d3"));
      }));
    } else {
      return renderEventRow(item, lastItemInList ? "none" : "1px solid #333");
    }
  }), isIframe && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "40px 0 15px 0"
    }
  }, /*#__PURE__*/React.createElement(PaymentIcons, {
    whitelabel: whitelabel,
    showMobilePay: whitelabel.mobile_pay_active //We need to display the MobilePay icon only based on the whitelabel settings

  }))) : EVENT_LIST_STATUS === AsyncStates.Error ? /*#__PURE__*/React.createElement(_StyledP6, null, t("event.errorTryAgain")) : /*#__PURE__*/React.createElement(React.Fragment, null));
}

var _StyledDiv19 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv19",
  componentId: "sc-1v4msh0-29"
})({
  width: "100%"
});

var _StyledDiv20 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv20",
  componentId: "sc-1v4msh0-30"
})(["", ""], p => p._css14);

var _StyledH2 = _styled("h2").withConfig({
  displayName: "event_list___StyledH2",
  componentId: "sc-1v4msh0-31"
})({
  fontSize: 25,
  marginTop: 0,
  marginBottom: 10,
  "@media(max-width: 420px)": {
    fontSize: 18
  }
});

var _StyledSpan3 = _styled("span").withConfig({
  displayName: "event_list___StyledSpan3",
  componentId: "sc-1v4msh0-32"
})({
  "@media(max-width: 420px)": {
    fontSize: 14
  }
});

var _StyledDiv21 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv21",
  componentId: "sc-1v4msh0-33"
})({
  marginTop: 15,
  display: "flex"
});

var _StyledDiv22 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv22",
  componentId: "sc-1v4msh0-34"
})({
  marginRight: 10
});

var _StyledDiv23 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv23",
  componentId: "sc-1v4msh0-35"
})(p => ({
  cursor: "pointer",
  border: p._css15,
  backgroundColor: p._css16,
  color: p._css17,
  borderRadius: 5,
  userSelect: "none",
  padding: 10,
  textAlign: "center",
  width: 60,
  height: 60,
  fontSize: 40,
  position: "relative",
  margin: "0 15px",
  "@media(max-width: 420px)": {
    width: 44,
    height: 44,
    fontSize: 24,
    margin: 2.5
  }
}));

var _StyledDiv24 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv24",
  componentId: "sc-1v4msh0-36"
})(["", ""], p => p._css18);

var _StyledDiv25 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv25",
  componentId: "sc-1v4msh0-37"
})({
  position: "relative",
  "> div": {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: 3,
    height: 40,
    background: "#333"
  }
});

var _StyledDiv26 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv26",
  componentId: "sc-1v4msh0-38"
})({
  transform: "translate(-50%, -50%) rotate(45deg)"
});

var _StyledDiv27 = _styled("div").withConfig({
  displayName: "event_list___StyledDiv27",
  componentId: "sc-1v4msh0-39"
})({
  transform: "translate(-50%, -50%) rotate(-45deg)"
});

var _StyledImg = _styled("img").withConfig({
  displayName: "event_list___StyledImg",
  componentId: "sc-1v4msh0-40"
})({
  width: "100%"
});

function GroupList({
  children,
  name,
  theme,
  earliestDate,
  latestDate,
  numberOfEvents,
  salesNotStarted,
  open,
  onToggle,
  showFewTicketsLeftTag,
  showTemporarilySoldOutTag
}) {
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_StyledDiv19, null, /*#__PURE__*/React.createElement(_StyledDiv20, {
    _css14: [{
      display: "flex",
      justifyContent: "space-between",
      padding: "15px 0"
    }, !open && {
      borderBottom: "1px solid #333"
    }]
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledH2, null, name), !open && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledSpan3, null, formatDateTimeRange(earliestDate, latestDate, {
    dateLocale: language === "da" ? "da-DK" : undefined,
    showTime: false,
    shortForm: window.innerWidth < 420
  })), /*#__PURE__*/React.createElement(_StyledDiv21, null, /*#__PURE__*/React.createElement(_StyledDiv22, null, /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, numberOfEvents, " events")), showTemporarilySoldOutTag && /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.temporarilySoldOut")), showFewTicketsLeftTag && /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.fewTicketsLeft")), salesNotStarted && /*#__PURE__*/React.createElement(DescriptiveTextLabel, null, t("event.ticketSalesNotStarted"))))), /*#__PURE__*/React.createElement(_StyledDiv23, {
    onClick: function () {
      onToggle();
    },
    _css15: "2px solid " + (open ? "#333" : theme.colour_primary),
    _css16: open ? "white" : theme.colour_primary,
    _css17: open ? "#333" : "white"
  }, /*#__PURE__*/React.createElement(_StyledDiv24, {
    _css18: [{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      transition: "150ms all"
    }, !open && {
      transform: "translate(-48%, -60%)"
    }]
  }, open ? /*#__PURE__*/React.createElement(_StyledDiv25, null, /*#__PURE__*/React.createElement(_StyledDiv26, null), /*#__PURE__*/React.createElement(_StyledDiv27, null)) : /*#__PURE__*/React.createElement(_StyledImg, {
    src: freeArrow
  })))), open && children);
}